// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_s-2";
export var blackBorderOnHover = "_s-7";
export var cell = "_s-6";
export var cellContainer = "_s-3";
export var checked = "_s-8";
export var disabled = "_s-5";
export var featuredIconCellContainer = "_s-9";
export var featuredIconTextContainer = "_s-b";
export var featuredIconWrapper = "_s-a";
export var noBorder = "_s-c";
export var orangeSelectedRow = "_2w-3";
export var overflowableText = "_s-0";
export var overflowableTextContainer = "_s-1";
export var row = "_t-0";
export var rowCheckboxCell = "_s-4";
export var selectableTable = "_2w-2";